import React from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

import { AuthUserContext } from '../session';

import SignOutBtn from './SignOutBtn';
import * as ROUTES from '../constants/routes';

const Navigation = () => (
  <div>
    <AuthUserContext.Consumer>
      {authUser => (authUser ? <NavigationAuth /> : <NavigationNonAuth />)}
    </AuthUserContext.Consumer>
  </div>
);

const NavigationAuth = () => (
  <ul className="Navigation">
    <li>
      <Link to={ROUTES.HOME}>Home</Link>
    </li>
    <li>
      <Link to={ROUTES.CREATE}>Create</Link>
    </li>
    <li>
      <Link to={ROUTES.PROFILE}>Profile</Link>
    </li>
    <li>
      <SignOutBtn />
    </li>
  </ul>
);

const NavigationNonAuth = () => (
  <ul className="Navigation">
    <li>
      <Link to={ROUTES.LOG_IN}>Log in</Link>
    </li>
  </ul>
);

export default Navigation;
